export default "__VITE_ASSET__CMkx14UE__";